import {
  REQUEST_RECIPE_SUGGESTION_REQUEST,
  REQUEST_RECIPE_SUGGESTION_SUCCESS,
  REQUEST_RECIPE_SUGGESTION_ERROR,
  CANCEL_RECIPE_SUGGESTION_REQUEST,

  FETCH_RECIPE_SUGGESTION_REQUEST,
  FETCH_RECIPE_SUGGESTION_SUCCESS,
  FETCH_RECIPE_SUGGESTION_ERROR,
  RELOAD_RECIPE_SUGGESTION_SUCCESS,

  FETCH_RECIPE_DETAIL_REQUEST,
  FETCH_RECIPE_DETAIL_SUCCESS,
  FETCH_RECIPE_DETAIL_ERROR,

  RESET_RECIPE_SUGGESSTION,
  UPDATE_FAVORITE,

  IRequestRecipeSuggestionRequest,
  IRequestRecipeSuggestionResponse,

  IFetchRecipeSuggestionRequest,
  IFetchRecipeSuggestionResponse,

  IFetchRecipeDetailResponse,
  SEARCH_RECIPE_REQUEST,
  SEARCH_RECIPE_SUCCESS,
  SEARCH_RECIPE_ERROR,

  RESET_SEARCH_RECIPE,
  SEARCH_AI_RECIPE_REQUEST,
  SEARCH_AI_RECIPE_SUCCESS,
  SEARCH_AI_RECIPE_ERROR,
} from './types';

export interface DataState {
  request: {
    params: IRequestRecipeSuggestionRequest,
    data: IRequestRecipeSuggestionResponse;
    loading: boolean;
    error: Error | null;
    isCancel: boolean;
  },
  list: {
    params: IFetchRecipeSuggestionRequest,
    data: IFetchRecipeSuggestionResponse[];
    loading: boolean;
    error: Error | null;
  },
  detail: {
    data: IFetchRecipeDetailResponse;
    loading: boolean;
    error: Error | null;
  },
  listSearch: {
    params: {
      page: number;
      page_size: number;
      keyword: string;
    },
    data: [];
    loading: boolean;
    error: Error | null;
    type:string;
    loadingSearchAi: boolean;
  },
}

const initRequest = {
  params: {
    ingredient_ids: [],
    request_ingredients: [],
    flavor_item_ids: [],
  } as IRequestRecipeSuggestionRequest,
  data: {} as IRequestRecipeSuggestionResponse,
  loading: false,
  error: null,
  isCancel: true,
}

const initList = {
  params: {
    page: 1,
    page_size: 14,
  } as IFetchRecipeSuggestionRequest,
  data: [] as IFetchRecipeSuggestionResponse[],
  loading: true,
  error: null,
}

const initDetail = {
  data: {} as IFetchRecipeDetailResponse,
  loading: false,
  error: null,
}

const initListSearch = {
  params: {
    page: 1,
    page_size: 10,
    keyword: '',
  },
  data: [] as [],
  loading: false,
  error: null,
  type: '',
  loadingSearchAi: false,
}

const initialState: DataState = {
  request: initRequest,
  list: initList,
  detail: initDetail,
  listSearch: initListSearch,
};

const authReducer = (
  state: DataState = initialState,
  action: any,
): DataState => {
  switch (action.type) {
    // reuqest recipe suggestion
    case REQUEST_RECIPE_SUGGESTION_REQUEST:
      return {
        ...state,
        request: {
          ...state.request,
          params: action.payload,
          loading: true,
          data: {} as IRequestRecipeSuggestionResponse,
          error: null,
          isCancel: false,
        },
        list: initList, // clear list when has new request
        // detail: initDetail, // clear detail when has new request
      };
    case REQUEST_RECIPE_SUGGESTION_SUCCESS:
      return {
        ...state,
        request: {
          ...state.request,
          data: action.payload,
          loading: false,
          error: null,
        }
      };
    case REQUEST_RECIPE_SUGGESTION_ERROR:
      return {
        ...state,
        request: {
          ...state.request,
          loading: false,
          error: action.payload,
        }
      };
    case CANCEL_RECIPE_SUGGESTION_REQUEST:
      return {
        ...state,
        request: {
          ...state.request,
          isCancel: true,
          error: null,
        },
      };

    // list recipe suggestion
    case FETCH_RECIPE_SUGGESTION_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          params: action.payload,
          data: action.payload.page === 1 ? [] : state.list.data,
          loading: true,
          error: null,
        }
      };
    case FETCH_RECIPE_SUGGESTION_SUCCESS: {
      const { params } = state.list 
      const newData = params.page_size === 0
        ? action.payload
        : action.payload.data
      return {
        ...state,
        list: {
          ...state.list,
          data: params.page === 1 ? newData : state.list.data.concat(newData),
          loading: false,
          error: null,
        }
      };
    }
    case FETCH_RECIPE_SUGGESTION_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.payload,
        }
      };
    case RELOAD_RECIPE_SUGGESTION_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          data: action.payload.data,
        }
      };
    }

    // recipe detail
    case FETCH_RECIPE_DETAIL_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          data: state.detail.data.id === action.payload.id ? state.detail.data : initDetail.data,
          loading: true,
          error: null,
        }
      };
    case FETCH_RECIPE_DETAIL_SUCCESS: 
      return {
        ...state,
        detail: {
          ...state.detail,
          data: action.payload,
          loading: false,
          error: null,
        }
      };
    case FETCH_RECIPE_DETAIL_ERROR:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          error: action.payload,
        }
      };
    case UPDATE_FAVORITE:
      return {
        ...state,
        detail: state.detail?.data?.id === action.payload.id
          ? {
            ...state.detail,
            data: {
              ...state.detail.data,
              is_favorite: action.payload.is_favorite,
            }
          }
          : state.detail,
        list: {
          ...state.list,
          data: state.list.data.map((e: any) => e.id === action.payload.id
            ? {
              ...e,
              is_favorite: action.payload.is_favorite,
            }
            : e
          )
        }
      };
      case RESET_RECIPE_SUGGESSTION:
      return {
        ...initialState,
        detail: state.detail,
        listSearch: state.listSearch,
      };
      case SEARCH_RECIPE_REQUEST:
      return {
        ...state,
        listSearch: {
          ...state.listSearch,
          params: action.payload,
          data: action.payload.page === 1 ? [] : state.listSearch.data as [],
          loading: true,
          error: null,
          type: action.type,
        }
      };
    case SEARCH_RECIPE_SUCCESS: {
      const { params } = state.listSearch 
      const newData = params.page_size === 0
        ? action.payload
        : action.payload.data
      return {
        ...state,
        listSearch: {
          ...state.listSearch,
          data: params.page === 1 ? newData : state.listSearch.data.concat(newData) as [],
          loading: false,
          error: null,
          type: action.type,
        }
      };
    }
    case SEARCH_RECIPE_ERROR:
      return {
        ...state,
        listSearch: {
          ...state.listSearch,
          loading: false,
          error: action.payload,
          type: action.type,
        }
      };

      case SEARCH_AI_RECIPE_REQUEST:
      return {
        ...state,
        listSearch: {
          ...state.listSearch,
          data: action.payload.page === 1 ? [] : state.listSearch.data as [],
          loading: true,
          error: null,
          type: action.type,
          loadingSearchAi: true,
        }
      };
    case SEARCH_AI_RECIPE_SUCCESS: {
      const newData = action.payload.data 
      const newList = [newData]
      return {
        ...state,
        listSearch: {
          ...state.listSearch,
          data: newList as [],
          loading: false,
          error: null,
          type: action.type,
          loadingSearchAi: false,
        }
      };
    }
    case SEARCH_AI_RECIPE_ERROR:
      return {
        ...state,
        listSearch: {
          ...state.listSearch,
          loading: false,
          error: action.payload,
          type: action.type,
          loadingSearchAi: false,
        }
      };

    case RESET_SEARCH_RECIPE:
      return {
        ...state,
        listSearch: {
          params: {
            page: 1,
            page_size: 10,
            keyword: '',
          },
          data: [] as [],
          loading: false,
          error: null,
          type: '',
          loadingSearchAi: false,
        }
      };

    default:
      return state;
  }
};

export default authReducer
